module.exports = {
      id: "android-small-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#android-small",
      toString: function () {
        return this.url;
      }
    }